import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NotificationModel } from '../../notifications/notification.model';

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {
    @Input() message: NotificationModel;
    @Input() count: number;
    @Output() onDismissed: EventEmitter<string> = new EventEmitter();
    @Output() onDismissedAll: EventEmitter<void> = new EventEmitter();

    ngOnInit() { }

    dismiss(): void {
        this.onDismissed.emit();
    }

    dismissAll(): void {
        this.onDismissedAll.emit();
    }

    showCount(): boolean {
        return this.count > 1;
    }

    getContent(): string {
        if (!this.message) { return null; }
        return this.message.content.trim();
    }

    getCount(): number {
        return this.count - 1;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/components/notification/notification.component.ts